<template>
    <div>
        <div data-aos="fade-up">
            <home-banner></home-banner>
            <client-logos></client-logos>
        </div>
        <whychoosehk></whychoosehk>
        <HkPlatform></HkPlatform>
        <TailoredSolutions></TailoredSolutions>
        <FeatureSections></FeatureSections>
        <the-experts></the-experts>
        <ExploreIndustries></ExploreIndustries>
        <ClientReviews></ClientReviews>
        <ArticlesBlogs></ArticlesBlogs>
        <AskQuestion></AskQuestion>
        <GrowBetter></GrowBetter>
    </div>
</template>

<script>
import HomeBanner from "./HomeBanner.vue";
import ClientLogos from "./ClientLogos.vue";
import TailoredSolutions from "./TailoredSolutions.vue";
import ExploreIndustries from "./ExploreIndustries.vue";
import HkPlatform from "./HkPlatform.vue";
import ClientReviews from "./ClientReviews";
import blogposts from "./blogposts.vue";
import AskQuestion from "./AskQuestion.vue";
import GrowBetter from "./GrowBetter.vue";
import MobServices from "./MobServices.vue";
import ClientTestimonialsCarousel from "./ClientTestimonialsCarousel.vue";
import whychoosehk from "./WhyChooseHk.vue";
import FeatureSections from "./FeatureSections.vue";
import ArticlesBlogs from "@/views/about-us/ArticlesBlogs.vue";
import TheExperts from "./TheExperts.vue";



export default {
    components: {
        HomeBanner,
        ClientLogos,
        ClientReviews,
        ArticlesBlogs,
        whychoosehk,
        ExploreIndustries,
        HkPlatform,
        blogposts,
        AskQuestion,
        GrowBetter,
        MobServices,
        ClientTestimonialsCarousel,
        TailoredSolutions,
        FeatureSections,
        TheExperts

 
    },
    name: "mainpage",
    data() {
        return {
            showMorePoints: false,
            SalientFeaturesList: [],
            SalientFeatures: [
                {
                    img_url: "optimize.svg",
                    text_key: "salient_features.salient_features_key1",
                    sub_text: "salient_features.salient_features_value1",
                },
                {
                    img_url: "state.svg",
                    text_key: "salient_features.salient_features_key2",
                    sub_text: "salient_features.salient_features_value2",
                },
                {
                    img_url: "next_g.svg",
                    text_key: "salient_features.salient_features_key3",
                    sub_text: "salient_features.salient_features_value3",
                },
                {
                    img_url: "rate_management.svg",
                    text_key: "salient_features.salient_features_key4",
                    sub_text: "salient_features.salient_features_value4",
                },
                {
                    img_url: "point_of_sale.svg",
                    text_key: "salient_features.salient_features_key5",
                    sub_text: "salient_features.salient_features_value5",
                },
                {
                    img_url: "inventory.svg",
                    text_key: "salient_features.salient_features_key6",
                    sub_text: "salient_features.salient_features_value6",
                },
                {
                    img_url: "multi_reporting.svg",
                    text_key: "salient_features.salient_features_key7",
                    sub_text: "salient_features.salient_features_value7",
                },
                {
                    img_url: "dashboard.svg",
                    text_key: "salient_features.salient_features_key8",
                    sub_text: "salient_features.salient_features_value8",
                },
                {
                    img_url: "payment_processing.svg",
                    text_key: "salient_features.salient_features_key9",
                    sub_text: "salient_features.salient_features_value9",
                },
                {
                    img_url: "property_admin.svg",
                    text_key: "salient_features.salient_features_key10",
                    sub_text: "salient_features.salient_features_value10",
                },
                {
                    img_url: "hkm.svg",
                    text_key: "salient_features.salient_features_key11",
                    sub_text: "salient_features.salient_features_value11",
                },
                {
                    img_url: "ems.svg",
                    text_key: "salient_features.salient_features_key12",
                    sub_text: "salient_features.salient_features_value12",
                },
                {
                    img_url: "group_bookings_module.svg",
                    text_key: "salient_features.salient_features_key13",
                    sub_text: "salient_features.salient_features_value13",
                },
                {
                    img_url: "wbe.svg",
                    text_key: "salient_features.salient_features_key14",
                    sub_text: "salient_features.salient_features_value14",
                },
                {
                    img_url: "c_accounts.svg",
                    text_key: "salient_features.salient_features_key15",
                    sub_text: "salient_features.salient_features_value15",
                },
            ],
        };
    },
    mounted() {
        this.ShowLess();
    },
    methods: {
        ShowMore() {
            this.showMorePoints = true;
            document.querySelector(".salient-features-right").scrollTo(0, 100);
            this.SalientFeaturesList = this.SalientFeatures;
        },
        ShowLess() {
            this.showMorePoints = false;
            this.SalientFeaturesList = this.SalientFeatures.slice(0, 4);
            // this.SalientFeaturesList = ({SalientFeatures, index} ) => SalientFeatures.slice(0, index)
        },
        markdownToHtml(message) {
            return marked(message);
        },
        ShowMoreEnterPrise() {
            this.showMorePoints = !this.showMorePoints;
        },
        GoEnterprise() {
            this.$router.push({
                name: "TheEnterprise",
            });
        },

        GoPms() {
            // this.$router.push({name:'PropertyManagement'})
            this.$router.push({
                name: "PropertyManagementSystem",
            });
        },
        GoRestaurants() {
            this.$router.push({
                name: "RetailKey",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.salient-features-bg {
    background: $bg-primary;
    padding: 7rem 0 6rem 0;

    .salient-img {
        position: relative;
        z-index: 1;
    }

    .egg-snakes {
        position: absolute;
        left: -3rem;
        bottom: 17rem;
        z-index: 1;
    }

    .grid_left {
        position: absolute;
        top: -3rem;
        left: -3rem;
        width: 180px;
        opacity: 0.7;
    }

    p {
        font-size: 1.125rem;
        color: $sub-title;
    }

    .salient-features-sub {
        padding-left: 4rem;

        .hk-sf-list {
            display: flex;
            align-items: baseline;

            ul {
                list-style-type: none;

                li {
                    color: $sub-title;
                    line-height: 28px;
                }
            }

            h2 {
                color: $p-color;
                font-size: 1.125rem;
                font-weight: 700;
                margin-left: 20px;
                margin-bottom: 0;
            }

            img {
                width: 40px;
                margin-right: 20px;
            }
        }

        .hk-height-increase {
            height: calc(800px);
            overflow-y: auto;
        }

        .hk-height-less {
            height: calc(700px);
            overflow-y: hidden;
        }

        .salient-features-right {
            overflow-x: hidden;
            margin-bottom: 2.5rem;

            .heading-box {
                padding-bottom: 1rem;
                position: sticky;
                top: 0px;
                z-index: 11;
                background: $white;
            }

            .row {
                padding-bottom: 2rem;
            }
        }
    }
}

.hk-platform {
    .clents-sub-heading {
        letter-spacing: -0.24px;
        line-height: 30px;

        p {
            // color: #454A58;

            color: $sub-title;
            font-size: 1.5rem;
            line-height: 35px;
        }
    }
}

.btn-view-more {
    border: 1px solid $main-headings;
    padding: 0.65rem;
    color: $main-headings;
    font-weight: 600;

    .rotate {
        transform: rotate(180deg);
    }
}

@media (max-width: 575.98px) {
    .salient-features-bg {
        padding: 1rem 5px 1rem 5px;

        .salient-features-sub {
            padding-left: 0.5rem;
            margin-top: 1rem;

            .hk-sf-list {
                display: block;

                h2 {
                    margin-left: 5px;
                    font-size: 1rem;
                }

                ul {
                    padding-left: 5px;

                    li {
                        line-height: 20px;
                        font-size: 14px;
                        letter-spacing: -0.28px;
                        padding: 0 0 5px 0px;
                    }
                }
            }

            .salient-features-right {
                height: auto;
                overflow-y: unset;
                overflow-x: unset;
                padding-left: 5px;
                padding-right: 5px;

                .row {
                    padding-bottom: 1rem;
                }

                .btn-view-more {
                    border: 1px solid $main-headings;
                    padding: 0.65rem;
                    color: $main-headings;
                    font-weight: 600;
                }
            }

            .show-more-points {
                display: flex;
            }

            .show-more-points {
                display: none;
            }
        }

        .hk-heading-text {
            font-size: 1.5rem;
            letter-spacing: -0.48px;
            line-height: 32px;
        }

        p {
            font-size: 1rem;
            line-height: 24px;
            letter-spacing: -0.32px;
        }

        .egg-snakes {
            position: absolute;
            left: -0.75rem;
            top: 16rem;
            z-index: 1;
            width: 60px;
        }
    }

    .rotate {
        transform: rotate(180deg);
    }

    .hk-platform {
        padding-right: 5px;
        padding-left: 5px;

        .hk-heading-text {
            font-size: 1.5rem;
            letter-spacing: -0.48px;
            line-height: 32px;
        }

        .clents-sub-heading {
            p {
                font-size: 1rem;
                line-height: 24px;
                letter-spacing: -0.32px;
            }
        }
    }
}

.salient-features-right::-webkit-scrollbar {
    width: 2px;
}

/* Track */
.salient-features-right::-webkit-scrollbar-track {
    box-shadow: unset;
    border-radius: 1px;
}

/* Handle */
.salient-features-right::-webkit-scrollbar-thumb {
    background: #454a5899;
    border-radius: 2px;
}

/* Handle on hover */
.salient-features-right::-webkit-scrollbar-thumb:hover {
    background: transparent;
}
</style>
